import cn from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";

import Button, { ButtonSize, ButtonTemplate } from "components/Button";
import { ArrowDownIconV2, ArrowUpIconV2 } from "components/Icons";

import styles from "./MergeActions.module.scss";

interface MergeActionsProps {
  onAcceptAll: () => void;
  onRejectAll: () => void;
  onNext: () => void;
  onPrevious: () => void;
  currentChunk: number;
  unresolvedChunks: number;
}

const MergeActions: React.FC<MergeActionsProps> = ({
  onAcceptAll,
  onRejectAll,
  onNext,
  onPrevious,
  currentChunk,
  unresolvedChunks,
}) => {
  const { t } = useTranslation();
  return (
    <div className={cn(styles.mergeActions)}>
      <div className={styles.content}>
        <div className={styles.chunksControls}>
          <div
            onClick={onPrevious}
            className={styles.navIcon}
            data-testid="merge-prev"
          >
            <ArrowUpIconV2 />
          </div>
          <div className={styles.unresolvedChunks}>
            {currentChunk} / {unresolvedChunks}
          </div>

          <div
            onClick={onNext}
            className={styles.navIcon}
            data-testid="merge-next"
          >
            <ArrowDownIconV2 />
          </div>
        </div>
        <div className={styles.actions}>
          <div className={styles.actionButton}>
            <Button
              onClick={onRejectAll}
              text={t("merge_editor.reject")}
              size={ButtonSize.Small}
              template={ButtonTemplate.Tertiary}
              dataTestid="merge-reject-all"
            />
          </div>
          <div className={styles.actionButton}>
            <Button
              onClick={onAcceptAll}
              text={t("merge_editor.accept")}
              size={ButtonSize.Small}
              template={ButtonTemplate.Secondary}
              dataTestid="merge-accept-all"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MergeActions;
